import React, { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  LocationHistoryContextValue,
  LocationHistoryProviderProps,
} from './types'

const LocationHistoryContext = createContext<
  LocationHistoryContextValue | undefined
>(undefined)

export const LocationHistoryProvider: React.FC<
  LocationHistoryProviderProps
> = ({ children }) => {
  const location = useLocation()
  const [history, setHistory] = useState<string[]>([])

  useEffect(() => {
    setHistory((prevHistory) => {
      const updatedHistory = [...prevHistory, location.pathname]
      return updatedHistory.slice(-2)
    })
  }, [location])

  return (
    <LocationHistoryContext.Provider value={{ history }}>
      {children}
    </LocationHistoryContext.Provider>
  )
}

export const useLocationHistory = (): string[] => {
  const context = useContext(LocationHistoryContext)
  if (!context) {
    throw new Error(
      'useLocationHistory must be used within a LocationHistoryProvider'
    )
  }
  return context.history
}

export default LocationHistoryProvider
